import { render } from "./StepTwo.vue?vue&type=template&id=0e4d16ca&scoped=true"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"

import "./StepTwo.vue?vue&type=style&index=0&id=0e4d16ca&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4d16ca"]])

export default __exports__